/* <soh-announcement data-speed="5">: rotates [data-message] children; pauses on hover/focus; static under reduced motion. */
class SohAnnouncement extends HTMLElement {
  connectedCallback() {
    this.msgs = [...this.querySelectorAll('[data-message]')]; if (this.msgs.length < 2) return;
    this.i = 0; this.msgs.forEach((m, j) => m.hidden = j !== 0);
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const start = () => { this.iv = setInterval(() => { this.msgs[this.i].hidden = true; this.i = (this.i + 1) % this.msgs.length; this.msgs[this.i].hidden = false; }, Number(this.dataset.speed || 5) * 1000); };
    const stop = () => clearInterval(this.iv);
    ['mouseenter', 'focusin'].forEach(e => this.addEventListener(e, stop)); ['mouseleave', 'focusout'].forEach(e => this.addEventListener(e, start));
    start();
  }
}
customElements.define('soh-announcement', SohAnnouncement);
